import { useEffect, useState } from "react";

type MediaSizes = {
    getSizes: (desktopSize: number|string, laptopSize: number|string, tabletSize: number|string, mobileSize: number|string) => number|string;
    isMobile: boolean;
    isTablet: boolean;
    isLaptop: boolean;
    isDesktop: boolean;
    isUnderDesktop: boolean;
    isUnderLargeLaptop: boolean;
    isUnderLaptop: boolean;
    isUnderTablet: boolean;
    windowWidth: number;
    windowHeight: number;
}

export const useMediaSizes = (): MediaSizes => {

    const [windowHeight, setWindowHeight] = useState<number>(typeof window !== 'undefined' ? window.innerHeight : 800);
    const [windowWidth, setWindowWidth] = useState<number>(typeof window !== 'undefined' ? window.innerWidth : 1200);

    const isMobile = () => windowWidth < 768;
    const isTablet = () => windowWidth >= 768 && windowWidth < 1024;
    const isLaptop = () => windowWidth >= 1024 && windowWidth < 1200;
    const isLargeLaptop = () => windowWidth >= 1200 && windowWidth < 1440;
    const isDesktop = () => windowWidth >= 1440;

    const getSizes = (desktopSize: number|string, laptopSize: number|string, tabletSize: number|string, mobileSize: number|string) => {
        if (isDesktop()) return desktopSize;
        else if (isLaptop()) return laptopSize;
        else if (isTablet()) return tabletSize;
        else return mobileSize;
    }

    useEffect(() => {
       
        const setSizes = () => {
            const width = window.innerWidth;
            const height = window.innerHeight;
            setWindowWidth(width);
            setWindowHeight(height);
        }

        // Set initial values
        setSizes();

        // Listen for resize events
        window.addEventListener('resize', setSizes);
        
        // Also listen for orientation change on mobile devices
        window.addEventListener('orientationchange', setSizes);

        return () => {
            window.removeEventListener('resize', setSizes);
            window.removeEventListener('orientationchange', setSizes);
        };
    }, []);

    return { 
        isMobile: isMobile(),
        isTablet: isTablet(),
        isLaptop: isLaptop(),
        isDesktop: isDesktop(),
        isUnderDesktop: isLargeLaptop() || isLaptop() || isTablet() || isMobile(),
        isUnderLargeLaptop: isLaptop() || isTablet() || isMobile(),
        isUnderLaptop: isTablet() || isMobile(),
        isUnderTablet: isMobile(),        
        getSizes,
        windowHeight,
        windowWidth,
    };
};